import { FilterFilled } from '@ant-design/icons';

// antd рисует триггер фильтра span-ом с tabIndex={-1}: с клавиатуры до него не
// дойти. Фокус и Enter/пробел даём иконке внутри — клик от неё всплывает к
// триггеру. Всплытие клавиши глушим: Enter на шапке переключил бы сортировку.
export function FilterTriggerIcon({ title, filtered }: { title: string; filtered: boolean }) {
  return (
    <FilterFilled
      tabIndex={0}
      role="button"
      aria-haspopup="dialog"
      aria-label={filtered ? `Фильтр «${title}», задан` : `Фильтр «${title}»`}
      onKeyDown={(e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.click();
      }}
    />
  );
}
